var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"closePosition":"top-6 right-3.5"}},[_c('AddFiles')],1)}
var staticRenderFns = []

export { render, staticRenderFns }